import React from "react";
import { Menu, Icon } from "semantic-ui-react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../../../../hooks";
import "./AdminMenu.scss";

export function AdminMenu() {
  const { pathname } = useLocation();

  // Corrige la destructuración para acceder al objeto user anidado
  const { user } = useAuth(); // Extrae el objeto user completo de useAuth
  const role = user?.user?.role; // Accede al role a través del objeto user anidado

  //console.log(role); // Imprime el role para verificar que se está accediendo correctamente

  const isAdmin = role === "admin"; // Verifica si el role es 'admin'
  const isClient = role === "client";
  const isUser = role === "user";
  const isPartner = role === "partner";
  const isInstitution = role === "institution";
  //const isTeacher = role === "teacher";
  //const isStudent = role === "student";

  //console.log('ADMIN', role); // Imprime si es admin

  const isCurrentPath = (path) => {
    return pathname === path; // Simplifica la función de comparación
  };

  return (
    <Menu fluid vertical icon text className="admin-menu">
      {isAdmin && (
        <>
          <Menu.Item
            as={Link}
            to="/admin/users-v2"
            active={
              isCurrentPath("/admin/users-v2") || isCurrentPath("/admin/users")
            }
          >
            <Icon name="users" />
            Usuarios
          </Menu.Item>
          <Menu.Item
            as={Link}
            to="/admin/dashboard"
            active={isCurrentPath("/admin/dashboard")}
          >
            <Icon name="dashboard" />
            Dashboard
          </Menu.Item>
          <Menu.Item
            as={Link}
            to="/admin/planes"
            active={isCurrentPath("/admin/planes")}
          >
            <Icon name="cart arrow down" />
            Planes
          </Menu.Item>
          <Menu.Item
            as={Link}
            to="/admin/billings"
            active={isCurrentPath("/admin/billings")}
          >
            <Icon name="money bill alternate" />
            Facturación
          </Menu.Item>

          {/*
            F6 M4 - Panel comercial de leads. Agrupa 3 pestanas: Leads,
            Correos funnel (antes "Drip correos" en este menu) y Promociones.
          */}
          <Menu.Item
            as={Link}
            to="/admin/leads"
            active={pathname.startsWith("/admin/leads")}
          >
            <Icon name="address book" />
            Leads
          </Menu.Item>

          {/* M13 F2.7 - Catalogo Live Games autorizados (SDK Unity) */}
          <Menu.Item
            as={Link}
            to="/admin/livegames"
            active={isCurrentPath("/admin/livegames")}
          >
            <Icon name="play circle" />
            Live Games
          </Menu.Item>

          {/*
            M08 - Educajob agrupa las 5 secciones del front publico
            (blog, cursos, menu, newsletter, usuarios cursos) en una
            sola entrada con tabs internos. Las URLs legacy redirigen.
          */}
          <Menu.Item
            as={Link}
            to="/admin/educajob"
            active={pathname.startsWith("/admin/educajob")}
          >
            <Icon name="briefcase" />
            Educajob
          </Menu.Item>

          <Menu.Item
            as={Link}
            to="/admin/salas"
            active={isCurrentPath("/admin/salas")}
          >
            <Icon name="object group" />
            Salas Mozilla Hubs
          </Menu.Item>

          <Menu.Item
            as={Link}
            to="/admin/virtualscenes"
            active={isCurrentPath("/admin/virtualscenes")}
          >
            <Icon name="accusoft" />
            Virtual Scenes
          </Menu.Item>
          {/*
            M11 - Una sola entrada "REVI" que agrupa Scenes y Formación
            via tabs internos en /admin/revi (estilo Educajob M08).
          */}
          <Menu.Item
            as={Link}
            to="/admin/revi"
            active={
              pathname.startsWith("/admin/revi") ||
              pathname === "/admin/reviscene"
            }
          >
            <Icon name="rocket" />
            REVI
          </Menu.Item>
          {/*
            Formacion K12: videos, guias PDF e informacion de uso de la
            plataforma para profesores e instituciones. Apartado propio,
            separado del de Formacion de REVI (que vive en /admin/revi).
          */}
          <Menu.Item
            as={Link}
            to="/admin/formacion"
            active={isCurrentPath("/admin/formacion")}
          >
            <Icon name="book" />
            Formación K12
          </Menu.Item>
          <Menu.Item
            as={Link}
            to="/admin/video360"
            active={isCurrentPath("/admin/video360")}
          >
            <Icon name="film" />
            Video 360
          </Menu.Item>
          <Menu.Item
            as={Link}
            to="/admin/assistance"
            active={isCurrentPath("/admin/assistance")}
          >
            <Icon name="id badge" />
            Asistentes virtuales
          </Menu.Item>

          <Menu.Item
            as={Link}
            to="/admin/clientdbcreator"
            active={isCurrentPath("/admin/clientdbcreator")}
          >
            <Icon name="address card" />
            Clientes DB
          </Menu.Item>

          <Menu.Item
            as={Link}
            to="/admin/simulators"
            active={isCurrentPath("/admin/simulators")}
          >
            <Icon name="cubes" />
            ES Simuladores
          </Menu.Item>

          <Menu.Item
            as={Link}
            to="/admin/servers"
            active={isCurrentPath("/admin/servers")}
          >
            <Icon name="cubes" />
            ES Servidores
          </Menu.Item>

          {/*
            M09 - EducaFiles: mini Drive admin para subir/listar/compartir
            assets (imagenes, videos, zips, docs) con URL externa.
          */}
          <Menu.Item
            as={Link}
            to="/admin/educa-files"
            active={isCurrentPath("/admin/educa-files")}
          >
            <Icon name="cloud upload" />
            EducaFiles
          </Menu.Item>

          <Menu.Item
            as={Link}
            to="/admin/tiptap-test"
            active={isCurrentPath("/admin/tiptap-test")}
          >
            <Icon name="align center" />
            Tiptap Test
          </Menu.Item>
        </>
      )}
      {isClient && (
        <>
          <Menu.Item
            as={Link}
            to="/admin/clientdb"
            active={isCurrentPath("/admin/clientdb")}
          >
            <Icon name="address card" />
            Clientes DB
          </Menu.Item>

          <Menu.Item
            as={Link}
            to="/admin/blog"
            active={isCurrentPath("/admin/blog")}
          >
            <Icon name="comment alternate" />
            Blog
          </Menu.Item>
        </>
      )}

      {isUser && (
        <>
          <Menu.Item
            as={Link}
            to="/admin/blog"
            active={isCurrentPath("/admin/blog")}
          >
            <Icon name="comment alternate" />
            Blog
          </Menu.Item>
        </>
      )}

      {isPartner && (
        <>
          <Menu.Item
            as={Link}
            to="/admin/register"
            active={isCurrentPath("/admin/register")}
          >
            <Icon name="clipboard" />
            Profile
          </Menu.Item>
          <Menu.Item
            as={Link}
            to="/admin/institution"
            active={isCurrentPath("/admin/institution")}
          >
            <Icon name="building outline" />
            Institution
          </Menu.Item>
        </>
      )}
      {isInstitution && (
        <>
          <Menu.Item
            as={Link}
            to="/admin/inst/profile"
            active={isCurrentPath("/admin/inst/profile")}
          >
            <Icon name="university" />
            Institución
          </Menu.Item>
          <Menu.Item
            as={Link}
            to="/admin/inst/teachers"
            active={isCurrentPath("/admin/inst/teachers")}
          >
            <Icon name="user" />
            Docentes
          </Menu.Item>
        </>
      )}
    </Menu>
  );
}
